import { ClerkProvider } from "@clerk/clerk-react";
import type { ReactNode } from "react";

// Get the publishable key from environment or use a placeholder
const CLERK_PUBLISHABLE_KEY =
	"pk_live_Y2xlcmsuY2NmbGFyZS50b29scy5zYXZhZ2UuaGsk";

if (!CLERK_PUBLISHABLE_KEY) {
	throw new Error("Missing Clerk Publishable Key");
}

interface ClerkContextProviderProps {
	children: ReactNode;
}

export function ClerkContextProvider({ children }: ClerkContextProviderProps) {
	return (
		<ClerkProvider
			publishableKey={CLERK_PUBLISHABLE_KEY}
			signInUrl="/auth/sign-in"
			signUpUrl="/auth/sign-up"
			afterSignInUrl="/dashboard"
			afterSignUpUrl="/dashboard"
		>
			{children}
		</ClerkProvider>
	);
}
